module.exports = __webpack_public_path__ + "img/pedalo.c396084c.svg";